// extracted by mini-css-extract-plugin
export default {"editor":"CodeEditor_editor__0JbAt","btns_container":"CodeEditor_btns_container__rtBYK","editor_component":"CodeEditor_editor_component__xlbu5","addbtn":"CodeEditor_addbtn__GXw67"};